import { getCurrentTime } from 'src/utils';
import { FruitPropsType, FishermansType,isLockedType } from 'src/views/harvesting/fruit-profile/model';
import * as _ from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const oldFruitProfileToNewFormat = (fruitProfile: any):FruitPropsType => {

  //RETURN FRUIT, BECAUSE IT IS ALREADY THE MOST UPDATED FORMAT
  if (fruitProfile?.version && fruitProfile?.version === 3) {
    return fruitProfile;
  }
  //IT IS FRUIT STRUCTURE VERION 2
  else {
    return {
      id: fruitProfile.id,
      name: fruitProfile.name,
      ...(fruitProfile.image ? { image: fruitProfile.image } : {}),
      ...(fruitProfile.others ? { others: fruitProfile.others } : {}),
      platform: fruitProfile.platform,
      url:fruitProfile.url,
      ...(fruitProfile.blacklist ? { isBlacklist: fruitProfile.blacklist } : {}),
      ...(fruitProfile.centerClass ? { blacklistCenterClass: fruitProfile.centerClass } : {}),
      ...(fruitProfile.blacklistReason ? { blacklistReason: fruitProfile.blacklistReason } : {}),
      fishermans: fruitProfile.fisherman ? [{
        name: fruitProfile.fisherman,
        createdAt: fruitProfile.createdAt ?? {
          seconds: 1580515200,
          nanoseconds: 0
        },
        methodType: 'Not sure'
      }] : [],
      ...(fruitProfile.blacklist ? { isBlacklist: fruitProfile.blacklist } : {}),
      ...(fruitProfile.blacklistReason ? { blacklistReason: fruitProfile.blacklistReason } : {}),
      ...(fruitProfile.blacklistDate ? { blacklistDate: fruitProfile.blacklistDate } : {}),
      version: 2,
      createdAt: fruitProfile.createdAt ?? {
        seconds: 1580515200,
        nanoseconds: 0
      }
    };
  }
};

export const sortFruitProfilesByCreatedAt = (fruits: FruitPropsType[]):FruitPropsType[] => {
  return fruits.sort((a: FruitPropsType, b: FruitPropsType) => {

    if(!a.createdAt){
      return 1;
    }

    if(!b.createdAt){
      return 1;
    }
    if (a.createdAt.seconds < b.createdAt.seconds) {
      return 1;
    }
    if (a.createdAt.seconds > b.createdAt.seconds) {
      return -1;
    }
    return 0;
  });
};

export const oldFruitsProfileToNewFormatReader = (fruits: any[]):FruitPropsType|false=>{
  const sortedFruits = sortFruitProfilesByCreatedAt(fruits.map(oldFruitProfileToNewFormat));
  const version3Fruits =sortedFruits.filter(x=>x.version ===3);

  if(version3Fruits.length>0){

    let fishermans=[] as FishermansType[];
    let facebookGroupIds =[] as string[];
    let isLocked =[] as isLockedType[];

    version3Fruits.forEach((currentFruit)=>{
      fishermans= _.uniqBy([...fishermans,...(currentFruit['fishermans']??[])],'name');
      facebookGroupIds= _.uniq([...facebookGroupIds,...(currentFruit['facebookGroupIds']??[])]);
      isLocked= _.uniqBy([...isLocked,...(currentFruit['isLocked']??[])],'name');
    });
    const url = sortedFruits.find(x=>x.url!==undefined)?.url;
    // console.log('mergedResult',{...version3Fruits[0],
    //   fishermans,
    //   facebookGroupIds,
    //   isLocked
    // }, url,url);
    return {...version3Fruits[0],
      fishermans,
      facebookGroupIds,
      isLocked,
      ...(url ? { url } : {}),      
    };
  }

  const mergedResult = mergeFruitProfiles(sortedFruits);
 

  return mergedResult;
};


export const mergeFruitProfiles = (fruits: FruitPropsType[]):FruitPropsType|false => {
  if(fruits.length ===0){
    return false;
  }
  const sortedFruits = sortFruitProfilesByCreatedAt(fruits);
  const oldestV3doc = [...sortedFruits].reverse().find(fruit => fruit.version === 3) as FruitPropsType;

  let newFishmanLists = [] as FishermansType[];
  sortedFruits.forEach((x: FruitPropsType) => {
    const oldFishmanList = Array.from( x.fishermans!==undefined?x.fishermans:[]);
    newFishmanLists = [...newFishmanLists, ...oldFishmanList];
  });
  
  const mergedFruit= Object.assign({},...sortedFruits.reverse());
  return {
    ...mergedFruit,
    ...(oldestV3doc ? { id:oldestV3doc.id } : {}),
    createdAt:sortedFruits[0].createdAt,
    fishermans: newFishmanLists, 
    
  };
};

export const mergedFruit = (targetFruit: FruitPropsType,checkedFruit:FruitPropsType|false)=>{
  const targetFruitWithDetail:FruitPropsType = {...targetFruit, name:targetFruit.name.toLowerCase().trim(), createdAt:  getCurrentTime()};
  const mergeFruits =checkedFruit?mergeFruitProfiles([targetFruitWithDetail,checkedFruit]):targetFruitWithDetail;
  return mergeFruits as FruitPropsType;
};